import React, { useState } from 'react';

import { NavLink, useHistory } from 'react-router-dom';

import Tooltip from 'Components-redesign/Tooltip';
import { useI18n } from 'Hooks';

import Props from '../types';
import { validateFormData } from '../validationRules';
import {
  ErrorMessage,
  Form,
  InnerWrapper,
  InnerWrapperSmall,
  Input,
  InputWrapper,
  InputWrapperName,
  Label,
  PasswordHint,
  PasswordToolTip,
  RegisterLinkWrapper,
  RegisterText,
  StepCounter,
  SubmitButton,
  Title,
  VisibilityIcon,
  Wrapper,
} from './styles';

const RegisterUserView: React.FunctionComponent<Props> = ({
  onSetField,
  phoneOrEmail,
  password,
  confirmPassword,
  firstName,
  lastName,
  loading,
}) => {
  const { t } = useI18n();
  const [passVisible, setPassVisible] = useState(false);
  const [confirmPassVisible, setConfirmPassVisible] = useState(false);
  const [isTooltipShowing, setShowTooltip] = useState(false);
  const [errors, setErrors] = useState({});

  const tooltipMessage = t('Register.PasswordRestrictions');

  const history = useHistory();

  const goToAddCompany = () => {
    const errorData = validateFormData(
      {
        phoneOrEmail,
        password,
        confirmPassword,
        firstName,
        lastName,
      },
      t,
    );
    setErrors(errorData);
    if (!Object.keys(errorData).length) {
      history.push('/register/add-company');
    }
  };

  return (
    <Wrapper>
      <InnerWrapper>
        <StepCounter>{t('Register.StepFirst')}</StepCounter>
        <Title>{t('General.Welcome')}</Title>
        <Form autoComplete="off">
          <InputWrapperName>
            <InnerWrapperSmall>
              <Label>{t('Register.FirstName')}</Label>
              <Input
                key="firstName"
                onChange={(val) => onSetField('firstName', val.target.value)}
                type="text"
                autoComplete="off"
                autoCorrect="off"
                autoCapitalize="off"
                spellCheck="false"
                value={firstName}
                autoFocus
              />
            </InnerWrapperSmall>
            <InnerWrapperSmall>
              <Label>{t('Register.LastName')}</Label>
              <Input
                key="lastName"
                onChange={(val) => onSetField('lastName', val.target.value)}
                type="text"
                autoComplete="off"
                autoCorrect="off"
                autoCapitalize="off"
                spellCheck="false"
                value={lastName}
              />
            </InnerWrapperSmall>
          </InputWrapperName>
          <ErrorMessage>{errors['firstName']}</ErrorMessage>
          <ErrorMessage>{errors['lastName']}</ErrorMessage>
          <InputWrapper>
            <Label>{t('Register.EmailOrUsername')}</Label>
            <Input
              key="phone"
              onChange={(val) => onSetField('phoneOrEmail', val.target.value)}
              type="text"
              autoComplete="off"
              autoCorrect="off"
              autoCapitalize="off"
              spellCheck="false"
              value={phoneOrEmail}
            />
          </InputWrapper>
          <ErrorMessage>{errors['phoneOrEmail']}</ErrorMessage>
          <InputWrapper>
            <Label>{t('Register.Password')}</Label>
            <Input
              key="password"
              autoComplete="off"
              autoCorrect="off"
              autoCapitalize="off"
              spellCheck="false"
              value={password}
              onChange={(val) => onSetField('password', val.target.value)}
              onFocus={() => setShowTooltip(true)}
              onBlur={() => setShowTooltip(false)}
              type={passVisible ? 'text' : 'password'}
            />
            <VisibilityIcon isVisible={passVisible} onClick={() => setPassVisible(!passVisible)} />
            <PasswordHint>
              <PasswordToolTip>
                <Tooltip
                  message={tooltipMessage}
                  isShowing={isTooltipShowing}
                  bottomPos={4}
                  position={'right'}
                />
              </PasswordToolTip>
            </PasswordHint>
          </InputWrapper>
          <ErrorMessage>{errors['password']}</ErrorMessage>
          <InputWrapper>
            <Label>{t('Register.ConfirmPassword')}</Label>
            <Input
              key="confirmPassword"
              autoComplete="off"
              autoCorrect="off"
              autoCapitalize="off"
              spellCheck="false"
              value={confirmPassword}
              onChange={(val) => onSetField('confirmPassword', val.target.value)}
              type={confirmPassVisible ? 'text' : 'password'}
            />
            <VisibilityIcon
              isVisible={confirmPassVisible}
              onClick={() => setConfirmPassVisible(!confirmPassVisible)}
            />
          </InputWrapper>
          <ErrorMessage>{errors['confirmPassword']}</ErrorMessage>
          <SubmitButton type="button" isLoading={loading} onClick={goToAddCompany}>
            {loading ? <>{t('General.LoadingThreeDots')}</> : <span>{t('General.Next')}</span>}
          </SubmitButton>
        </Form>
        <RegisterText>
          {t('Register.AlreadyAMember')}
          <NavLink to="/">
            <RegisterLinkWrapper>{t('General.Login')}</RegisterLinkWrapper>
          </NavLink>
        </RegisterText>
      </InnerWrapper>
    </Wrapper>
  );
};

export default RegisterUserView;
